/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_No_Eligible_JobsInputs */

const en_batch_no_eligible_jobs = /** @type {(inputs: Batch_No_Eligible_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No eligible jobs selected.`)
};

const fr_batch_no_eligible_jobs = /** @type {(inputs: Batch_No_Eligible_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun poste admissible n'a été sélectionné.`)
};

const de_batch_no_eligible_jobs = /** @type {(inputs: Batch_No_Eligible_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden keine passenden Stellen ausgewählt.`)
};

const it_batch_no_eligible_jobs = /** @type {(inputs: Batch_No_Eligible_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun posto di lavoro idoneo selezionato.`)
};

const ru_batch_no_eligible_jobs = /** @type {(inputs: Batch_No_Eligible_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подходящих вакансий не отобрано.`)
};

const es_batch_no_eligible_jobs = /** @type {(inputs: Batch_No_Eligible_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha seleccionado ningún puesto que cumpla los requisitos.`)
};

const zh_cn2_batch_no_eligible_jobs = /** @type {(inputs: Batch_No_Eligible_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择符合条件的职位。`)
};

const ja_batch_no_eligible_jobs = /** @type {(inputs: Batch_No_Eligible_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該当する求人は見つかりませんでした。`)
};

const hi_batch_no_eligible_jobs = /** @type {(inputs: Batch_No_Eligible_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई भी योग्य पद चयनित नहीं हुआ।`)
};

const pt_pt2_batch_no_eligible_jobs = /** @type {(inputs: Batch_No_Eligible_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma vaga elegível selecionada.`)
};

/**
* | output |
* | --- |
* | "No eligible jobs selected." |
*
* @param {Batch_No_Eligible_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_no_eligible_jobs = /** @type {((inputs?: Batch_No_Eligible_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_No_Eligible_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_no_eligible_jobs(inputs)
	if (locale === "de") return de_batch_no_eligible_jobs(inputs)
	if (locale === "it") return it_batch_no_eligible_jobs(inputs)
	if (locale === "ru") return ru_batch_no_eligible_jobs(inputs)
	if (locale === "es") return es_batch_no_eligible_jobs(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_no_eligible_jobs(inputs)
	if (locale === "ja") return ja_batch_no_eligible_jobs(inputs)
	if (locale === "hi") return hi_batch_no_eligible_jobs(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_no_eligible_jobs(inputs)
	return en_batch_no_eligible_jobs(inputs)
});